/**
 * HTTP method constant for GET requests, representing string "GET".
 */
export const GET = 'GET';
/**
 * HTTP method constant for POST requests, representing string "POST".
 */
export const POST = 'POST';
/**
 * HTTP method constant for PUT requests, representing string "PUT".
 */
export const PUT = 'PUT';
/**
 * HTTP method constant for PATCH requests, representing string "PATCH".
 */
export const PATCH = 'PATCH';
/**
 * HTTP method constant for DELETE requests, representing string "DELETE".
 */
export const DELETE = 'DELETE';
